import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {HTHGameAssets} from "../HTHGameAssets";
import {HTH} from "../HTH";
import {HTHHelper} from "../utils/HTHHelper";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {HTHSound} from "../sound/HTHSound";


export class HTHWinCap extends PIXI.Container implements StageLayer {
    private _spine: PIXI.spine.Spine;
    private _countUp: BasicBitmapCountUp;
    private _countUpCopy: BasicBitmapCountUp;
    private _capWinX: PIXI.BitmapText;
    private _capWinXCopy: PIXI.BitmapText;
    //   private _blackOverlay: PIXI.Sprite;
    private _fireEffect: TimelineSprite;
    private _loopTl: gsap.core.Timeline | null;
    private _shineEffect: TimelineSprite;
    private _fireSpine: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "WinCapView";
        this.init();
    }

    public hideWinCap(): gsap.core.Timeline {
        const hideWinCapTL: gsap.core.Timeline = gsap.timeline();

        if (this._loopTl) {
            this._loopTl.kill();
            this._loopTl = null;
        }

        hideWinCapTL.to([this, this._spine, this._capWinX, this._shineEffect], 0.2, {alpha: 0});//, this._blackOverlay
        hideWinCapTL.add(HTH.gameViewContainer.hideOverlay(), "<");
        hideWinCapTL.add(() => {
            this.visible = false;
            this._spine.visible = false;
            this._countUp.visible = false;
            this._countUpCopy.visible = false;
            this._fireSpine.visible = false;
            //   this._blackOverlay.visible = false;
            this._capWinX.alpha = 0;
            this._capWinXCopy.alpha = 0;
            HTH.backgroundElements.setMode(HTH.model.data.nextMode);
            this.restoreOrder();
        });

        return hideWinCapTL;
    }

    public onResize(): void {
        if (!this.visible) {
            return;
        }
        HTH.gameViewContainer.resetOverlay();
        this.resetBlackOverlay();
    }

    public showWinCap(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            totalWin: number = HTH.model.gameData.accumulatedRoundWin,
            animDuration: number = this._spine.spineData.findAnimation("capwin").duration;
        this._countUp.stopAt(0);
        this._countUpCopy.stopAt(0);

        tl.add(() => {
            this._spine.visible = true;
            this._countUp.visible = true;
            this._countUpCopy.visible = true;
            // this._blackOverlay.visible = true;
            this._fireSpine.visible = true;
            this._countUp.alpha = 1;
            this._countUpCopy.alpha = 0;
            this.visible = true;
            this.onResize();
            this.alpha = 1;
            if (!HTH.model.isBigWin) {
                HTH.gameViewContainer.addOverlay(0.2, 0.7);
            }
            HTH.gameViewContainer.scatterCollector.showScatterCollector(false);
        }, 0);

        tl.add([
            gsap.to([this._countUp, this._spine], 0.1, {alpha: 1}),
            gsap.to([this._countUp.scale, this._countUpCopy], 0.1, {x: 1, y: 1, ease: "sine.in"}),
            this._countUp.getCountAnimation(0, totalWin, animDuration),
            this._countUpCopy.getCountAnimation(0, totalWin, animDuration),
            HTHHelper.playSpineWithTimeline(this._spine, 0, "capwin"),
            gsap.to(this._countUpCopy, {alpha: 1, duration: animDuration}),
            () => {
                HTHSound.playTrack(HTHSound.CAPWIN_COUNTUP);
            }
        ], 0);
        tl.add(() => {
            HTHSound.playTrack(HTHSound.CAPWIN_COUNTUP_END);
        }, animDuration);
        return tl;
    }

    public playFireEffect(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._spine.autoUpdate = true;
            this._spine.state.setAnimation(0, "capwin2", false);
            this._spine.state.addAnimation(0, "capwin_idle", true, this._spine.skeleton.data.findAnimation("capwin2")?.duration);
        }, 0);
        tl.to(this, {duration: 1.778 - this._fireSpine.skeleton.data.findAnimation("wincap_reveal").duration});
        tl.add(this.playCountupFireEffect());
        tl.to([this._countUp, this._countUpCopy], {alpha: 0, duration: 0.5}, "<");
        tl.to(this._capWinX, {alpha: 1, duration: 0.1}, "-=0.1");
        tl.add([
            () => {
                HTHSound.playTrack(HTHSound.CAPWIN_LOOP, 1, Number.MAX_VALUE);
                HTH.keypadPlugin.setWin(HTH.model.gameData.accumulatedRoundWin, true, HTHHelper.isWinBelowStake());
                this._shineEffect.position.set(358, 496);
                this._shineEffect.alpha = 1;
                this.playShineOnCountup();
            }], ">");
        return tl;
    }

    private playShineOnCountup(): void {
        if (!this._loopTl) {
            this._loopTl = gsap.timeline({repeat: -1});
        }
        this._loopTl.to([this._capWinX.scale], {x: 1.2, y: 1.2, duration: 0.2});
        this._loopTl.to([this._capWinX.scale], {x: 1, y: 1, duration: 0.2});
        this._loopTl.add(<gsap.core.Timeline><unknown>this._shineEffect.getAnimationAutoShowHide().timeScale(0.7));
        this._loopTl.to(this, {duration: 1});
    }

    private resetBlackOverlay(): void {

        const bounds = NolimitApplication.screenBounds
        /*        this._blackOverlay.width = bounds.width;
                this._blackOverlay.height = bounds.height;
                this._blackOverlay.position.x = bounds.left;
                this._blackOverlay.position.y = bounds.top;*/
    }

    private init(): void {
        this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("MaxWin"));
        this._spine.name = "wincap spine";
        this._spine.position.set(360, 360);
        this._spine.visible = false;
        this._spine.alpha = 0;
        this._spine.scale.set(0.6);

        this._capWinX = new PIXI.BitmapText("20   066x", {
            fontName: HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 35
        })
        this._capWinX.name = "capWinWays";
        this._capWinX.alpha = 0;
        this._capWinX.position.set(360, 460);
        this._capWinX.anchor = new PIXI.Point(0.5, 0.5);

        this._capWinXCopy = new PIXI.BitmapText("20   066x", {
            fontName: HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 35,
            tint: PIXI.BLEND_MODES.MULTIPLY
        })
        this._capWinXCopy.name = "capWinWaysCopy";
        this._capWinXCopy.alpha = 0;
        this._capWinXCopy.position.set(360, 460);
        this._capWinXCopy.anchor = new PIXI.Point(0.5, 0.5);

        this._countUp = new BasicBitmapCountUp({
            fontName: HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 160,
            tint: 0xffffff
        }, 520, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 510);
        this._countUp.stopAt(0);
        this._countUp.visible = false;
        this._countUp.alpha = 0;
        this._countUp.name = "countup";

        this._countUpCopy = new BasicBitmapCountUp({
            fontName: HTHGameAssets.BITMAP_FONT_WIN_COUNT_UP_RED,
            fontSize: 160,
            tint: 0xffffff
        }, 520, new PIXI.Point(0.5, 0.5));
        this._countUpCopy.position.set(0, 0);
        this._countUpCopy.stopAt(0);
        this._countUpCopy.visible = false;
        this._countUpCopy.alpha = 0;
        this._countUpCopy.name = "countupRedCopy";
        this._countUp.addChild(this._countUpCopy);

        this._shineEffect = new TimelineSprite(HTH.assetLoader.getTextures("maxwinShine"));
        this._shineEffect.position.set(360, 496);
        this._shineEffect.blendMode = PIXI.BLEND_MODES.ADD;
        this._shineEffect.anchor.set(0.5, 0.5);
        this._shineEffect.alpha = 0;
        this._shineEffect.name = "shineEffect";

        this._fireSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("MaxWinFire"))
        this._fireSpine.position.set(360, 470);
        this._fireSpine.name = "maxWinFireAnim"


        this.visible = false;

        this.restoreOrder();
        this.resetBlackOverlay();

    }

    private restoreOrder(): void {
        this.addChild(this._spine, this._countUp/*, this._blackOverlay,*/, this._capWinX, this._capWinXCopy, this._fireSpine, this._shineEffect);
    }

    private playCountupFireEffect(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(HTHHelper.playSpineWithTimeline(this._fireSpine, 0, "wincap_reveal"));
        return tl;

    }

}